import ChaseLogo from './ChaseLogo';
import BoaLogo from './BoaLogo';
import WellsFargoLogo from './WellsFargoLogo';
import CitiLogo from './CitiLogo';
import TdLogo from './TdLogo';
import PncLogo from './PncLogo';
import RelayLogo from './RelayLogo';
import AmexLogo from './AmexLogo';

const insLogoMapping: Record<string, { name: string; logo: React.ComponentType<any> }> = {
    ins_5: {
        name: 'Citibank Online',
        logo: CitiLogo,
    },
    ins_10: {
        name: 'American Express',
        logo: AmexLogo,
    },
    ins_13: {
        name: 'PNC Bank',
        logo: PncLogo,
    },
    ins_14: {
        name: 'TD Bank',
        logo: TdLogo,
    },
    ins_56: {
        name: 'Chase',
        logo: ChaseLogo,
    },
    ins_127989: {
        name: 'Bank of America',
        logo: BoaLogo,
    },
    ins_127991: {
        name: 'Wells Fargo',
        logo: WellsFargoLogo,
    },
    ins_117228: {
        name: 'Relay',
        logo: RelayLogo,
    },
};

export default insLogoMapping;
